import React, { useCallback, useEffect } from 'react';
import { ReactComponent as UpgradeIcon } from 'assets/icons/upgrade.svg';
import ReactTooltip from 'react-tooltip';

import { useCurrentVersion, useGetLatestVersion } from './hook';
import { useActivity } from './activity';

const versionRegExp = /^v(\d+\.)?(\d+\.)?(\*|\d+)$/;

const t = {
  text: 'You are running an outdated version. <br /> Please click to get the last version',
};

const UpgradeAlertComponent = ({ className }) => {
  const latestVersion = useGetLatestVersion();
  const currentVersion = useCurrentVersion();
  const latestVersionLooksLikeAVersion = versionRegExp.test(latestVersion);

  const { enableActivityHandler, disableActivityHandler } = useActivity({
    currentVersion,
  });

  const handleButtonClick = useCallback(() => {
    window.location.reload();
  }, []);

  useEffect(() => {
    enableActivityHandler();
    return () => {
      disableActivityHandler();
    };
  }, [enableActivityHandler, disableActivityHandler]);

  if (!latestVersion || !currentVersion) {
    return null;
  }

  if (latestVersion === currentVersion) {
    return null;
  }

  if (!latestVersionLooksLikeAVersion) {
    return null;
  }

  return (
    <>
      <button
        className={className}
        data-tip={t.text}
        data-for="upgrade-tooltip"
        onClick={handleButtonClick}
        data-testid="upgrade_button"
      >
        <UpgradeIcon />
      </button>
      <ReactTooltip id="upgrade-tooltip" effect="solid" multiline />
    </>
  );
};

export default UpgradeAlertComponent;
